import moment from 'moment-timezone';

export const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 12 },
};

export const layoutEdit = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18 },
};

/* eslint-disable no-template-curly-in-string */
export const validateMessages = {
    required: '${label} is required!',
    types: {
        email: '${label} is not a valid email!',
        number: '${label} is not a valid number!',
    },
    number: {
        range: '${label} must be between ${min} and ${max}',
    },
};
/* eslint-enable no-template-curly-in-string */

export const handleFormChange = (form): boolean => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    return hasErrors;
};

export const maleProfileImg: string = 'https://profile-images.xing.com/static/nobody_m.96x96.jpg';
export const femaleProfileImg: string = 'https://profile-images.xing.com/static/nobody_f.96x96.jpg';

export const setCookie = (cname, cvalue) => {
    document.cookie = `${cname}=${cvalue};`;
};

export const getCookie = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const cleanAllCookies = () => {
    var Cookies = document.cookie.split(';');
    // set 1 Jan, 1970 expiry for every cookies
    for (var i = 0; i < Cookies.length; i++) document.cookie = Cookies[i] + '=;expires=' + new Date(0).toUTCString();
};

export const couponGenerator = () => {
    var coupon = '';
    var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 7; i++) {
        coupon += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return coupon.toUpperCase();
};

export const stripTypenames = (value) => {
    if (Array.isArray(value)) {
        return value.map(stripTypenames);
    } else if (value !== null && typeof value === 'object') {
        const newObject = {};
        for (const property in value) {
            if (property !== '__typename') {
                newObject[property] = stripTypenames(value[property]);
            }
        }
        return newObject;
    } else {
        return value;
    }
};

export const capitalizeWords = (value: string): string => {
    if (!value) return value;

    return value.toLowerCase().replace(/(^|\s|-|')\w/g, (char) => char.toUpperCase());
};

export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            resolve(reader.result as string);
        };

        reader.onerror = (error) => {
            reject(error);
        };
    });
};

export const extractIdCardData = (data) => {
    const containerList = data?.ContainerList?.List;
    if (!containerList) return null;

    const textFieldsContainer = containerList.find((item) => item.Text?.fieldList);

    const fields = textFieldsContainer?.Text?.fieldList;
    if (!fields) return null;

    // helper
    const getField = (name) => fields.find((f) => f.fieldName === name)?.valueList?.[0]?.value;

    // ✅ Extract fields
    const surname = getField('Surname');
    const givenNames = getField('Given Names');
    const fullName = getField('Surname And Given Names') || `${surname || ''} ${givenNames || ''}`.trim();

    const documentNumber = getField('Document Number');
    const personalNumber = getField('Personal Number'); // exists mostly in DL
    const birthDate = getField('Date of Birth');

    return {
        fullName,
        documentNumber,
        personalNumber,
        birthDate,
    };
};

export const convertDateToFormat = (timestamp: string | Date, format: string) => {
    const date = moment(Number(timestamp)).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format(format);

    return date;
};

export const getLastSeenText = (date) => {
    const diffMinutes = moment().diff(moment(date), 'minutes');
    const diffHours = moment().diff(moment(date), 'hours');
    const diffDays = moment().diff(moment(date), 'days');

    if (diffMinutes < 60) {
        return `${diffMinutes} min ago`;
    }

    if (diffHours < 24) {
        return `${diffHours} h ago`;
    }

    return `${diffDays} day ago`;
};

export const getTaxiIcon = (isOnline: boolean) => ({
    url: '/assets/pin_taxi.png',
    scaledSize: new google.maps.Size(40, 40),
    labelOrigin: new google.maps.Point(20, 50),
});

export const getRiderIcon = (isOnline: boolean) => ({
    url: '/assets/pin_passenger.png',
    scaledSize: new google.maps.Size(35, 35),
    labelOrigin: new google.maps.Point(18, 45),
});

export const getStartIcon = (isOnline: boolean) => ({
    url: '/assets/pin_green.png',
    scaledSize: new google.maps.Size(35, 35),
    labelOrigin: new google.maps.Point(18, 45),
});

export const getEndIcon = (isOnline: boolean) => ({
    url: '/assets/pin_red.png',
    scaledSize: new google.maps.Size(35, 35),
    labelOrigin: new google.maps.Point(18, 45),
});

export const getDriverColor = (id: string) => {
    let hash = 0;

    for (let i = 0; i < id.length; i++) {
        hash = id.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;

    // Different saturation and brightness based on hash
    const saturation = 65 + (Math.abs(hash) % 25); // 65-90%
    const lightness = 40 + (Math.abs(hash >> 8) % 15); // 40-55%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};